module.exports = __webpack_public_path__ + "static/media/torso-mid-right-side.0f144d91.png";